module.exports = __webpack_public_path__ + "img/-s-组1拷贝@2x.19d45518.png";